(function () { if (window.__psScriptsListo) return; window.__psScriptsListo = true;
/* SOSband — scripts propios. Cada init comprueba que su elemento existe. */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ps-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('ps-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('ps-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Cuenta atrás: termina cada día a la hora elegida (por defecto, medianoche) */
  function initCuentaAtras() {
    document.querySelectorAll('[data-ps-cuenta]').forEach(function (el) {
      var hora = parseInt(el.getAttribute('data-hora-fin') || '24', 10);
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var modo = el.getAttribute('data-modo') || 'dia';
      function fin() {
        if (modo === '24h') {
          /* Bucle de 24 h por visitante: arranca en la primera visita y vuelve a empezar al llegar a cero */
          var KEY = 'ps-cuenta-fin', f24 = 0;
          try { f24 = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
          if (!f24 || f24 <= Date.now()) { f24 = Date.now() + 24 * 3600 * 1000; try { localStorage.setItem(KEY, String(f24)); } catch (e) {} }
          return new Date(f24);
        }
        var f = new Date(); f.setHours(hora, 0, 0, 0);
        if (f <= new Date()) f.setDate(f.getDate() + 1);
        return f;
      }
      var objetivo = fin();
      function pinta() {
        var d = objetivo - new Date();
        if (d <= 0) { objetivo = fin(); d = objetivo - new Date(); }
        var t = Math.floor(d / 1000);
        h.textContent = String(Math.floor(t / 3600)).padStart(2, '0');
        m.textContent = String(Math.floor((t % 3600) / 60)).padStart(2, '0');
        s.textContent = String(t % 60).padStart(2, '0');
      }
      pinta(); setInterval(pinta, 1000);
    });
  }

  /* Galería deslizable con flechas, puntos, miniaturas y gesto táctil */
  function initGaleria() {
    document.querySelectorAll('[data-ps-galeria]').forEach(function (g) {
      var pista = g.querySelector('.ps-gal__pista');
      var slides = g.querySelectorAll('.ps-gal__slide');
      if (!pista || slides.length < 2) return;
      var puntos = g.querySelectorAll('.ps-gal__punto');
      var minis = g.querySelectorAll('.ps-gal__mini');
      var i = 0;
      function ir(n) {
        i = (n + slides.length) % slides.length;
        pista.style.transform = 'translateX(' + (-100 * i) + '%)';
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        minis.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
      }
      g.querySelector('.ps-gal__flecha--prev').addEventListener('click', function () { ir(i - 1); });
      g.querySelector('.ps-gal__flecha--next').addEventListener('click', function () { ir(i + 1); });
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { ir(k); }); });
      minis.forEach(function (p, k) { p.addEventListener('click', function () { ir(k); }); });
      /* Avance automático: se pausa con el ratón encima o al tocar, y sigue después */
      var ms = parseInt(g.getAttribute('data-autoplay') || '0', 10);
      var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var reloj = null, pausaHasta = 0, encima = false;
      if (ms > 0 && !reducido) {
        reloj = setInterval(function () {
          if (encima || Date.now() < pausaHasta || document.hidden) return;
          ir(i + 1);
        }, ms);
        g.addEventListener('mouseenter', function () { encima = true; });
        g.addEventListener('mouseleave', function () { encima = false; });
        g.addEventListener('click', function () { pausaHasta = Date.now() + ms * 2; });
      }
      var x0 = null;
      g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; pausaHasta = Date.now() + (ms || 0) * 2; }, { passive: true });
      g.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      });
    });
  }

  /* Packs (variantes) + añadir al carrito + barra fija */
  function initProducto() {
    var raiz = document.querySelector('[data-ps-producto]');
    if (!raiz) return;
    var form = raiz.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var packs = raiz.querySelectorAll('.ps-pack');
    var boton = form && form.querySelector('[type="submit"]');
    var fija = document.querySelector('.ps-fija');
    var fijaPrecio = fija && fija.querySelector('.ps-fija__precio');
    var fijaAntes = fija && fija.querySelector('.ps-fija__antes');

    var colorActual = null;
    var botonesColor = raiz.querySelectorAll('[data-ps-color]');
    if (botonesColor.length) colorActual = botonesColor[0].getAttribute('data-ps-color');
    function datosColor(pack) {
      try { var m = JSON.parse(pack.getAttribute('data-colores') || '{}'); return m[colorActual] || null; } catch (e) { return null; }
    }
    function elegir(pack) {
      packs.forEach(function (p) { p.classList.toggle('is-activo', p === pack); });
      var r = pack.querySelector('input'); if (r) r.checked = true;
      var dc = datosColor(pack);
      if (dc) {
        pack.setAttribute('data-variante', dc.id); pack.setAttribute('data-disponible', String(dc.disp));
        pack.setAttribute('data-precio', dc.precio); pack.setAttribute('data-antes', dc.antes || '');
        if (r) r.value = dc.id;
      }
      if (dc) { pack.setAttribute('data-pc', dc.pc); pack.setAttribute('data-ac', dc.ac); }
      if (idInput) idInput.value = pack.getAttribute('data-variante');
      var disponible = pack.getAttribute('data-disponible') === 'true';
      if (boton) {
        boton.disabled = !disponible;
        boton.textContent = disponible ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
      }
      if (fijaPrecio) fijaPrecio.textContent = pack.getAttribute('data-precio');
      if (fijaAntes) fijaAntes.textContent = pack.getAttribute('data-antes') || '';
    }
    function pintarDto() {
      packs.forEach(function (p) {
        var el = p.querySelector('[data-ps-dto]'); if (!el) return;
        var pc = parseFloat(p.getAttribute('data-pc')), ac = parseFloat(p.getAttribute('data-ac'));
        var lg = (document.documentElement.lang || 'es').slice(0, 2), n = Math.round((1 - pc / ac) * 100); el.textContent = ac > pc ? (lg === 'en' ? 'You save ' + n + '%' : lg === 'fr' ? 'Économisez ' + n + ' %' : lg === 'it' ? 'Risparmi il ' + n + '%' : 'Ahorras ' + n + '%') : ''; el.style.display = ac > pc ? '' : 'none';
      });
    }
    packs.forEach(function (p) { p.addEventListener('click', function () { elegir(p); }); });
    var activo = raiz.querySelector('.ps-pack.is-activo');
    if (activo) elegir(activo);
    pintarDto();
    /* Selector de color: cambia la variante del pack marcado y lleva la galería a la foto de ese color */
    var fotoColor = { blanca: 0, gris: 2 };
    botonesColor.forEach(function (b) {
      b.addEventListener('click', function () {
        colorActual = b.getAttribute('data-ps-color');
        botonesColor.forEach(function (x) { var on = x === b; x.classList.toggle('is-activo', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        var nom = raiz.querySelector('[data-ps-color-nombre]'); if (nom) nom.textContent = colorActual;
        packs.forEach(function (p) { var dc = datosColor(p); if (dc) { p.setAttribute('data-variante', dc.id); p.setAttribute('data-disponible', String(dc.disp)); p.setAttribute('data-precio', dc.precio); p.setAttribute('data-antes', dc.antes || ''); p.setAttribute('data-pc', dc.pc); p.setAttribute('data-ac', dc.ac); var rr = p.querySelector('input'); if (rr) rr.value = dc.id; var pr = p.querySelector('.ps-pack__precio'); if (pr) pr.textContent = dc.precio; } });
        raiz.querySelectorAll('[data-ps-vlista]').forEach(function (u) { u.hidden = u.getAttribute('data-ps-vlista') !== colorActual; });
        packs.forEach(function (p) { var ant = p.querySelector('.ps-pack__antes'), dd = datosColor(p); if (dd) { if (ant) ant.textContent = dd.antes || ''; if (ant) ant.style.display = dd.antes ? '' : 'none'; } });
        pintarDto();
        var act = raiz.querySelector('.ps-pack.is-activo'); if (act) elegir(act);
        var k = fotoColor[colorActual.toLowerCase()];
        var punto = k !== undefined && raiz.querySelectorAll('.ps-gal__punto')[k];
        if (punto) punto.click();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (boton) boton.disabled = true;
        var drawer = document.querySelector('cart-drawer');
        var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : [];
        var raizUrl = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        fetch(raizUrl + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }], sections: secciones })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) { alert(res.description || res.message); return; }
          if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: null, sections: res.sections }); }
          else { window.location.href = raizUrl + 'cart'; }
        }).catch(function () { form.submit(); }).finally(function () { if (boton) boton.disabled = false; });
      });
    }

    /* En la vista previa, Shopify pone su barra negra abajo: subimos la barra de compra para que no la tape */
    if (fija) {
      var subir = function () {
        var pb = document.getElementById('preview-bar-iframe') || document.querySelector('iframe[src*="preview_bar"], #PBarNextFrameWrapper, .preview-bar');
        fija.style.bottom = pb && pb.offsetHeight ? pb.offsetHeight + 'px' : '0px';
      };
      subir(); var veces = 0, t = setInterval(function () { subir(); if (++veces > 20) clearInterval(t); }, 500);
      window.addEventListener('resize', subir);
    }

    if (fija && boton) {
      var fijaBtn = fija.querySelector('.ps-boton');
      if (fijaBtn) fijaBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          fija.classList.toggle('is-visible', fuera);
        }).observe(boton);
      }
    }
  }

  /* Recuadro de reseñas: pasa de una a otra cada 6 segundos */
  function initMini() {
    document.querySelectorAll('[data-ps-mini]').forEach(function (box) {
      var items = box.querySelectorAll('.ps-mini__item'), puntos = box.querySelectorAll('.ps-mini__punto');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-activo'); if (puntos[i]) puntos[i].classList.remove('is-activo');
        i = (i + 1) % items.length;
        items[i].classList.add('is-activo'); if (puntos[i]) puntos[i].classList.add('is-activo');
      }, 6000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initCuentaAtras(); initGaleria(); initProducto(); initMini();
  });
  document.addEventListener('shopify:section:load', function () { initReveal(); initCuentaAtras(); initGaleria(); });
})();

/* Móvil: puntos indicadores en los carruseles deslizables */
(function () {
  var SEL = ['.ps-uso__grid', '.ps-cf__puntos', '.jdgm-rev-widg__reviews'];
  function listo(c) {
    if (c.dataset.psDots || c.children.length < 2) return;
    c.dataset.psDots = '1';
    var d = document.createElement('div'); d.className = 'ps-dots'; d.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < c.children.length; i++) d.appendChild(document.createElement('i'));
    c.parentNode.insertBefore(d, c.nextSibling);
    function act() {
      var k = Math.round(c.scrollLeft / (c.scrollWidth - c.clientWidth || 1) * (c.children.length - 1));
      [].forEach.call(d.children, function (p, j) { p.className = j === k ? 'on' : ''; });
    }
    c.addEventListener('scroll', act, { passive: true }); act();
  }
  function barrer() { SEL.forEach(function (s) { [].forEach.call(document.querySelectorAll(s), listo); }); }
  document.addEventListener('DOMContentLoaded', barrer); window.addEventListener('load', barrer);
  var n = 0, t = setInterval(function () { barrer(); if (++n > 20) clearInterval(t); }, 700);
})();

/* Móvil: el carrusel de fotos "Pensada para el día a día" pasa solo cada 2 s (se pausa al tocar y solo corre si se ve) */
(function () {
  var c = null, visible = false, pausa = 0;
  function mover() {
    if (!c || !visible || document.hidden || Date.now() < pausa) return;
    var h = c.children; if (h.length < 2) return;
    var paso = h[1].offsetLeft - h[0].offsetLeft;
    if (c.scrollLeft + c.clientWidth >= c.scrollWidth - 4) c.scrollTo({ left: 0, behavior: 'smooth' });
    else c.scrollBy({ left: paso, behavior: 'smooth' });
  }
  function iniciar() {
    if (c || !window.matchMedia('(max-width: 749px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    c = document.querySelector('.ps-uso__grid'); if (!c) return;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (e) { c.addEventListener(e, function () { pausa = Date.now() + 5000; }, { passive: true }); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(c); else visible = true;
    setInterval(mover, 2000);
  }
  document.addEventListener('DOMContentLoaded', iniciar); window.addEventListener('load', iniciar);
})();

})();
